import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { generalUiTexts } from 'data/ui-texts';
import { exerciseToolsData } from 'data/tools-data';
import { gamesData } from 'data/games-data';
import {getIndexOfGameStep} from 'helpers/group-game-helper';
import {getText} from 'helpers/language-helper';
import Logo from 'components/logo/logo';
import Button from 'components/button/button';
import ProgressBar from 'components/progress-bar/progress-bar';
import GroupPlayers from 'components/group-players/group-players';
import GroupsPopup from 'components/groups-popup/groups-popup';
import InfoBox from 'components/info-box/info-box';
import './exercise-result.scss';

const ExerciseResult = ({
	game,
	companyData,
	gameStep,
	groups,
	handleGoToPage,
	confirmAndContinue,
	goToPrevGameStep,
	// toggleInfoPopup
}) => {

	const gameSteps = gamesData[game.type].gameSteps;

	/* Get data for this game's exercise tool  */
	const exerciseToolId = (game.exerciseTool ? game.exerciseTool : exerciseToolsData[0].id);
	let exerciseToolData = exerciseToolsData.find((tool) => {return tool.id === exerciseToolId;});

	/* Show group popup */
	const [showGroupsPopup, setShowGroupsPopup] = useState(false);

	/* Show question popup */
	const [showQuestionBox, setshowQuestionBox] = useState(false);
	const [questionBoxData, setQuestionBoxData] = useState({ title: '', text: '' });
	const handleshowQuestionBox = (questionsId, index) => {
		let currentQuestion = exerciseToolData.questions.find((question) => {
			return question.id === questionsId;
		});
		let questionBoxTitle = getText(currentQuestion.title, game.languageId);
		let questionBoxText = getText(currentQuestion.placeholder, game.languageId);
		setQuestionBoxData({ title: questionBoxTitle, text: questionBoxText });
		setshowQuestionBox(true);
	};	


	/* Confirm button status */
	let confirmBtnIsDisabled = true;
	let indexOfGameStep = gameSteps.findIndex((step) => {return step.id === gameStep;});
	if (indexOfGameStep >= 0 && indexOfGameStep + 1 < gameSteps.length) {
		if (game.gamePhase >= gameSteps[indexOfGameStep + 1].phase) confirmBtnIsDisabled = false;
	}

	return (
		<div className="ExerciseResult">
			<Logo
				onClick={() => {handleGoToPage('welcome');}}
			/>
			<ProgressBar
				gameType={game.type}
				gameStepId={gameStep}
				title={getText(exerciseToolData.title, game.languageId)}
				subtitle={getText(generalUiTexts.results, game.languageId)}
				// linkText={getText(generalUiTexts.flightInfo, game.languageId)}
				// toggleInfo={toggleInfoPopup}
				linkText={null}
				toggleInfo={null}
				backBtnLink={gameSteps[indexOfGameStep].backBtn ? goToPrevGameStep : null}
			/>
			<Button
				text={game.isPaused ? getText(generalUiTexts.paused, game.languageId) : (confirmBtnIsDisabled
					? getText(generalUiTexts.waiting, game.languageId)
					: getText(generalUiTexts.next, game.languageId)) }
				classes={game.isPaused ? ['paused'] : (confirmBtnIsDisabled ? ['next', 'waiting'] : ['next'])}
				isDisabled={game.isPaused ? true : confirmBtnIsDisabled}
				onClick={() => {confirmAndContinue(gameStep);}}
			/>

			<div className="ExerciseResult-container">
				<div className="ExerciseResult-groups" onClick={() => {setShowGroupsPopup(true);}}>
					<div className="ExerciseResult-header">
						<span>{getText(generalUiTexts.group, game.languageId)}</span>
					</div>
					<div className="ExerciseResult-body">
						{groups.map((group, gIndex) => {
							return (
								<div key={gIndex} className="ExerciseResult-group">
									<div className="ExerciseResult-groupTitle">{group.title}</div>
									<div className="ExerciseResult-groupPlayers">
										<GroupPlayers group={group} companyData={companyData} type="hover" />
									</div>

								</div>
							);
						})}
					</div>
				</div>

				{(exerciseToolData && exerciseToolData.questions) && <div className="ExerciseResult-groupAnswers">
					<div className="ExerciseResult-header">
						{exerciseToolData.questions.map((question, index) => {
							return (
								<div 
									key={index} 
									className="ExerciseResult-headerText"
									onClick={() => {handleshowQuestionBox(question.id, index);}}
								>
									<span>{getText(question.title, game.languageId)}</span>
								</div>
							);
						})}
					</div>
					<div className="ExerciseResult-body">
						{groups.map((group, gIndex) => {
							return (
								<div key={gIndex} className="ExerciseResult-groupRow">
									{exerciseToolData.questions.map((question, qIndex) => {
										let answer = null;
										if (getIndexOfGameStep(group.gameStep, game.type) >= 
										getIndexOfGameStep(gameStep, game.type)
										) {
											answer = (group.exerciseAnswers 
												?	group.exerciseAnswers.some((answer) => {
													return (answer.id === question.id);
												})
													? group.exerciseAnswers.find((answer) => {
														return (answer.id === question.id);
													}).value
													: null
												: null
											);
										}
										return (
											<div key={qIndex} className="ExerciseResult-groupAnswerContainer">
												<div className="ExerciseResult-groupAnswer">
													<span>{answer}</span>
												</div>
											</div>
										);
									})}
								</div>
							);
						})}
					</div>
				</div>}
			</div>

			{showQuestionBox && 
				<InfoBox
					title={questionBoxData.title}
					text={questionBoxData.text}
					handleClose={() => {setshowQuestionBox(false);}}
				/>
			}			

			{showGroupsPopup &&
				<GroupsPopup 
					languageId={game.languageId}
					groups={groups}
					companyData={companyData}
					setShowGroupsPopup={setShowGroupsPopup}
				/>
			}
		</div>
	);
};

ExerciseResult.propTypes = {
	game: PropTypes.object.isRequired,
	companyData: PropTypes.object,
	gameStep: PropTypes.string.isRequired,
	groups: PropTypes.array.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	confirmAndContinue: PropTypes.func.isRequired,
	goToPrevGameStep: PropTypes.func.isRequired,
	// toggleInfoPopup: PropTypes.func.isRequired,
};

export default ExerciseResult;
